export default {
  Andpenalties: 'Danos liquidados e penalidades',
  DeliveryFailed: 'Delivery failed, refunds are borne by Party A',
  PartybMust:
    'A Parte B não deve vender nenhum item de marca, e os ícones de marca não devem aparecer nas descrições dos produtos. Assim que a Parte A descobrir que há um produto ilegal ou incompatível com a marca na loja da Parte B, a Parte A suspenderá todos os pagamentos para a loja da Parte B em até 6 horas e interromperá todos os pagamentos. O valor específico da multa é mostrado no Anexo',
  abandonedRequests: 'Pedido Abandonado',
  abandonedorder: 'Pedido Abandonado',
  accesshelpcenter: 'Acesse nosso centro de ajuda',
  accessoriesLessDelivery:
    'Lack of accessories, less delivery, refunds are borne by Party A',
  accesstoken: 'Token de Acesso',
  accessurlexample: 'Exemplo: your-store.com',
  accessurlprefix:
    'O URL não pode conter os seguintes valores: www., https://, http://, /',
  actions: 'Ações',
  activate: 'ativar',
  activateStore:
    'Se for usar nossa loja online, ative-a para liberar todos os registros DNS.',
  active: 'ATIVO',
  active2: 'Ativo',
  actuallyPrice: 'Preço atual',
  addDomainTips1: 'Vincule um domínio que já pertence a você.',
  addDomainTips2:
    'Você também pode vincular um subdomínio. Por favor, certifique-se de começar o seu formulário com "pay" ou "pago". Ex.:',
  addDomainTips3: 'Não use',
  addDomainTips4: 'Fique de olho! Para que seu domínio funcione,',
  addDomainTips5:
    'você precisa comprá-lo e configurá-lo com um serviço de hospedagem',
  addDomainTips6: 'ou outro.',
  addDomainTips7: 'Se tiver dúvidas, consulte nosso',
  addPopup: 'Engadir Coupon',
  addastore: 'Adicionar uma loja',
  addstore: 'adicionar Loja',
  afterEachSuccessful:
    'Após cada transação bem-sucedida da Parte B, a Parte A retirará 5% do valor da transação bem-sucedida da Parte B e manterá a margem rotativa na conta da Parte A enquanto a transfere para a Parte B. A margem rotativa na conta da Parte A para cada transação será mantida por 45 dias, e o valor será liberado para a Parte B após 45 dias.',
  afterSales:
    'Este é o e-mail de pós-venda. Os clientes enviam dúvidas pós-venda para esse e-mail, e a equipe de pós-venda responderá.',
  afterVerification:
    'Se o motivo do reembolso se enquadrar nas seguintes cinco situações após a verificação, o reembolso será arcado pela Parte B:',
  agreetoNY: 'Ao criar uma conta, você concorda com os',
  alreadyhaveanaccount: 'Já tem uma conta?',
  and: 'e',
  apikey: 'Chave API / ID do cliente',
  apisecretkey: 'Chave secreta da API / Segredo',
  ativo: 'ATIVO',
  backgroundColor: ' Cor de Fundo',
  basicinformation: 'Informações básicas',
  blacklisted:
    'If the customer is blacklisted, the refund shall be cancelled and borne by Party B',
  blacklistedCustomer: 'Cliente na lista negra, cancelar reembolso',
  borneByParty: `Due to Party B's failure to pay in time, the customer requests to cancel the order, and the refund shall be borne by Party B`,
  borneParty:
    'If the product is not satisfactory (does not like it), the refund shall be borne by Party A',
  buttonText: 'Texto do Botão',
  cancel: 'cancelar',
  cancellationAnd:
    'If the order is not shipped and the customer requests cancellation and refund, the refund shall be borne by Party B',
  cardPaymentsAnswer:
    'Assim que o cliente depositar em nossa conta, o dinheiro será transferido para sua carteira no dia seguinte.',
  cardPaymentsTitile:
    'Quanto tempo demora para o valor ser transferido para minha conta depois que os clientes fazem pedidos?',
  carddesc: 'CARTÕES, BOLETO, DEPÓSITO BANCÁRIO E PIX',
  changeAddress:
    'For requests to change the address after the goods have been shipped, the refund shall be borne by Party B',
  classic: 'Clássico',
  collaboratorRequestCode:
    'Armazene permissões e códigos de colaboradores (seu e-mail é _email_, processe a permissão)',
  collapsemenu: 'Recolher menu',
  confirm: 'Confirmar',
  confirmedAndThe:
    'If the order is to be confirmed and the customer does not reply for more than 2 days, the refund shall be borne by Party B',
  confirmpassword: 'Confirme sua senha',
  contentTerms: 'Termos de conteúdo',
  convertedOrderPaid: 'Pedido Convertido (Pago)',
  convertedOrderUnpaid: 'Pedido Convertido (Não Pago)',
  copy: 'copiar',
  correspondingPenalties:
    'A Parte B deve cumprir as leis e regulamentos, bem como os requisitos de gerenciamento de riscos da Parte A e da organização do cartão para transações ilegais. Se a Parte B violar qualquer uma dessas regulamentações, a Parte B estará sujeita a penalidades e multas correspondentes.',
  countdownImage: 'Imagem de Contagem Regressiva',
  countdownTimer: 'Cronômetro',
  countdownBg: 'Fundo contagem',
  countdownTextColor: 'Texto contagem',
  country: 'País',
  coupon: 'Cupom',
  couponCode: 'Código de desconto (opcional)',
  creatanaccount: 'Crie uma conta',
  createTime: 'Hora de Criação',
  createaccounttitle:
    'Crie sua conta gratuita em nosso plano Básico, sem taxas mensais.',
  createfreeaccount: 'Crie uma conta gratuita',
  createpassword: 'Crie uma senha',
  currencyConversionAnswer:
    'Converta com base na taxa de câmbio oficial fornecida pelo provedor de pagamento',
  currencyConversionTitle: 'Problemas de conversão de moeda？',
  currentStoreName: 'A loja actual:',
  customerBuysMore:
    'If the customer buys more and wants to cancel and refund, the refund shall be borne by Party B',
  date: 'Data',
  days: 'días',
  defaultDomainTips:
    'Este é o dominio gratuito fornecidopela USAdrop. Ele sempre ir¡funcionar. Mas indicamosconfigurar um próprio.',
  delete: 'Excluir',
  deleteSelected: 'EXCLUIR SELECIONADOS',
  deleteSuccess: '¡Eliminación exitosa!',
  deletedSuccessfully: 'Excluído com sucesso',
  deliveryTime:
    'The customer receives the goods, the delivery time is too long, exceeding the store time limit, refunds are borne by Party A',
  disable: 'Desativar',
  disabledSuccessfully: 'Desativado com sucesso',
  discount: 'Desconto',
  discountAmount: 'Valor do desconto',
  discountPercent: 'Porcentagem de desconto',
  discountRate: 'Configurações de desconto',
  dnsNormal: 'A configuração do registro DNS está normal',
  dnsNotConfigured: 'Registro DNS não configurado ou não propagado.',
  dnsRecordsTitle: 'Registros DNS para sua loja online',
  domain: 'Domínio',
  domainbtntext: 'Configurar',
  domaintitle: 'Configure o mesmo domínio da sua loja Shopify aqui.',
  eachSuccessfulTransaction:
    'Após cada transação bem-sucedida da Parte B, a Parte A retirará 10% do valor da transação bem-sucedida da Parte B e manterá a margem rotativa na conta da Parte A enquanto a transfere para a Parte B. A margem rotativa na conta da Parte A para cada transação será mantida por 45 dias, e o valor será liberado para a Parte B após 90 dias.',
  edit: 'Editar',
  editstore: 'Editar Loja',
  email: 'E-mail',
  emailContent: 'Conteúdo do E-mail',
  emailReminders: 'Configuração de promoção',
  emailRemindersDesc: 'Configure lembretes por e-mail e descontos nos pedidos',
  emailTemplateConfig: ' Configuração do modelo de email',
  emailTemplateConfigDesc: 'Conteúdo personalizado do email',
  emailTitle: 'Sujeto de correio electrónico',
  embedPaymentMethods:
    'Use e-mails para incentivar os clientes a completar o pagamento em diferentes momentos para aumentar as taxas de conversão de pedidos.',
  emptyCouponDesc:
    'Após configurar o cupom, um pop-up para resgatar o cupom aparecerá após a conclusão do pagamento, incentivando o usuário a usar o cupom para um melhor desconto.',
  emptyCouponTitle: 'Configure seu cupom',
  enable: 'Ativar',
  enableCouponTips:
    'Apenas um cupom pode estar ativo por vez. Desative os outros antes de prosseguir!',
  enabledSuccessfully: 'Ativado com sucesso',
  end: 'Fim',
  endDate: 'Data de término',
  enter: 'Entrar',
  entercorrectemail: 'Por favor, insira o formato correto do e-mail',
  enteremailandpassword: 'Digite seu e-mail e senha',
  example: 'Exemplo',
  faqs: 'FAQs',
  firstPaymentChannel: 'Método de Pagamento para o Primeiro Pedido',
  firsttimeaNY: 'Primeira vez no USAdrop?',
  followInstructions: 'Siga as instruções',
  followingPenalties:
    'Além das multas mencionadas acima, aqueles que violarem seriamente os regulamentos enfrentarão as seguintes penalidades:',
  forBrazil: 'Para o Brasil：',
  forMexico: 'Para México/Chile/Colômbia/Peru：',
  forPaymentFailure:
    'For payment failure, the refund shall be borne by Party B',
  forShopify:
    'Quando você se inscreve no Shopify, sua loja online recebe um URL "myshopify.com".',
  forgetpassword: 'Esqueci minha senha',
  fullname: 'Nome completo',
  goodsNum: 'itens',
  gtm: 'Container ID',
  gtmRequired: 'Container ID is required',
  gtmDomain: 'URL do contêiner do servidor',
  gtmDomainRequired: 'URL do contêiner do servidor is required',
  googleid: 'ID da métrica',
  googlekey: 'Chave secreta da API do Measurement Protocol',
  googleidRequired: 'O ID de medição é obrigatório',
  googlekeyRequired: 'Segredos da API do Protocolo de Medição',
  hasBeenSigned:
    'Logistics shows that it has been signed, but the customer has not received it, refunds are borne by Party A',
  hasquestions: 'Tem perguntas?',
  headerImage: 'Imagem de Cabeçalho',
  helpCenter: 'Centro de Ajuda',
  helpaddress: 'bento.me/enchentesrs',
  hi: 'Oi',
  holding: '1、Retenção',
  home: 'Inicio',
  howtocontribute: 'Veja como contribuir em',
  howtoset: 'Como configurar',
  identifyyourself: 'Identifique-se',
  imitationBrand: 'Imitação/marca imitada',
  inActive: 'INATIVO',
  inativo: 'INATIVO',
  info: 'Informações',
  installtitle: 'Instale o Checkout Transparente do USAdrop na sua loja Shopify.',
  invitationNumber: 'Número de convite',
  invitationNumberError:
    'Por favor, Digite o número do seu convite para concluir o seu cadastro',
  isConfirmDelete: 'Você tem certeza de que deseja excluí-lo?',
  kEmail: 'E-mail',
  kName: 'Nome',
  learnMore: 'clique aqui para saber mais.',
  lengthLimit: 'O comprimento deve ser de 3 a 8',
  letteringPattern:
    'Product quality (size, color difference, damage, stains, thread ends, odor, wrinkles, fading, shrinkage, lettering, pattern, logo, accessories), refunds are borne by Party A',
  like: 'gosto',
  linkNewDomain: 'Vincular novo domínio',
  liquidatedDamages: 'Danos liquidados e penalidades.',
  logaccount: 'Você está logado em:',
  loginsuccess: 'login bem-sucedido!',
  logout: 'Sair',
  logoutSYS: 'Deseja sair do sistema?',
  lougoutsuccess: 'Saída com sucesso!',
  markAsActive: 'Marcar como ativo',
  markAsInactive: 'Marcar como inativo',
  min: 'mín',
  mydomain: 'Meu domínio',
  mydomains: 'Meus domínios',
  mydomainsdesc:
    'Gerencie seus domínios aqui. Vincule seus domínios e configure-os para serem o endereço virtual da sua loja e checkout.',
  name: 'NOME:',
  needhelp: 'Rio Grande do Sul precisa de sua ajuda.',
  newaffiliations: 'Novos Países',
  newpixel: 'Novo pixel',
  nextPage: ' Próxima Página',
  no: 'Não.',
  noDomain: 'Sem domínio',
  noStatus: 'Sem Estado',
  noUseDefaultDomain: 'Não use o domínio de pagamento padrão de USAdrop!',
  noUseOrgin: 'Não use http:// https:// nem www',
  nocountriesavailable: 'Nenhum país disponível',
  nodatareadtitle: 'Leia nosso artigo completo',
  nodatastartsell:
    'Quando você começar a vender, seus pedidos aparecerão aqui.',
  nodatatip1: 'Personalize sua loja com a aparência do seu negócio!',
  nodatatip2: 'Ofereça diferentes métodos de pagamento.',
  nodatatip3: 'Adicione boas fotos aos seus produtos.',
  nodatatip4: 'Faça descrições de produtos atraentes e use técnicas de SEO.',
  nodatatip5:
    'Invista em tráfego pago: anúncios nas redes sociais e Google Shopping.',
  nodatatip6: 'Veja se o preço de seus produtos é atraente.',
  nodatatip7:
    'Tenha um canal de atendimento ao cliente para responder perguntas',
  nodatatips: '7 dicas rápidas para você fazer sua primeira venda:',
  nodatatitle: 'Ainda não há pedidos para mostrar',
  nodeDescription: 'Descrição da situação de ativação',
  nodeName: 'Condições de ativação',
  operation: 'Status',
  order: 'Pedido',
  orderCancel: 'Cancelado',
  orderClosed: 'Fechado',
  orderConversion: 'Status de Pedido',
  orderDeliver: 'Enviado',
  orderEnd: 'Concluído',
  orderPaid: 'Pago',
  orderReceived: 'Entregue',
  orderToAnalyze:
    'Para analisar as origens dos diferentes pedidos e ajustar os anúncios em tempo hábil, nossos dados são mais precisos do que os do Facebook.',
  orderWaitPay: 'Pendente',
  ordernum: 'No. do Pedido',
  ordertime: 'Tempo do Pedido',
  originurl: 'Endereço do site',
  originurlexample: 'Exemplo: sua-loja.myshopify.com',
  originurlprefix:
    'O URL não pode conter os seguintes valores: www., https://, http://, /, .br',
  package:
    'If the customer refuses to accept the package and requests a refund, The refund shall be borne by Party B',
  partyAProvides:
    'A Parte A fornece um serviço de garantia de reembolso para pedidos cooperativos a uma taxa de 1,5%. Se o motivo do reembolso for verificado como sendo a insatisfação do cliente com o produto após recebê-lo, a taxa de reembolso será paga pela Parte A e a Parte B não precisa arcar com as perdas relacionadas. Para cenários de uso específicos, consulte o apêndice do contrato do sistema.',
  partyAProvidesconsumers:
    'Para resguardar a estabilidade e a conformidade dos canais de pagamento, a Parte A atuará como a prestadora exclusiva dos serviços de pós-venda para a Parte B. A Parte B autoriza plenamente a Parte A a gerenciar todas as questões de pós-venda e a fornecer acesso às respectivas contas de e-mail de pós-venda. Qualquer tratamento de pós-venda realizado pela Parte B será considerado excepcional e dependerá do consentimento prévio da Parte A; nesses casos, a Parte B concederá à Parte A acesso total às contas de e-mail de pós-venda relevantes para monitoramento em tempo real. O descumprimento desta cláusula dará à Parte A o direito de suspender ou rescindir imediatamente o acesso da Parte B aos serviços de pagamento, sem qualquer responsabilidade.',
  partyProvides:
    'A Parte A fornece à Parte B serviços de pagamento e liquidação na Internet transfronteiriços, incluindo:',
  password: 'Senha',
  payBy: 'PAGAR POR',
  payment: 'Pagamento',
  paymentDateAnswer:
    'Você pode solicitar a retirada após pagar a taxa de atendimento do pedido. A retirada geralmente será processada dentro de 1-2 dias úteis. O horário final de chegada depende do seu banco.',
  paymentDateTitle:
    'Quanto tempo demora para o saque ser recebido depois que eu o inicio?',
  paymentDomain: 'Resolução de domínio CNAME',
  paymentRatesTitle: 'Pagamento e taxas para cada país？',
  paymentServicesToParty:
    'A Parte A fornece serviços de pagamento à Parte B, e a Parte B precisa informar à Parte A as informações de login da loja. A Parte A também fornece à Parte B serviços de consulta de informações relevantes sobre transações e liquidação, e a Parte B precisa cooperar com a Parte A para manter conjuntamente a estabilidade da conta do produto de pagamento.',
  paymentSetting: 'Configuração de pagamento',
  paymentTime: 'Hora de Pagamento',
  paymentaffiliations: 'Configurações de pagamento',
  paymentaffiliationsdesc:
    'As configurações para conduzir transações em sua loja e as configurações de idioma e país para a interface exibida aos clientes',
  shopifyCurrencyConfirmBRL:
    'Por favor, confirme que a moeda da sua loja Shopify está definida como BRL.',
  shopifyCurrencyConfirmCLP:
    'Por favor, confirme que a moeda da sua loja Shopify está definida como CLP.',
  shopifyCurrencyConfirmCOP:
    'Por favor, confirme que a moeda da sua loja Shopify está definida como COP.',
  shopifyCurrencyConfirmEUR:
    'Por favor, confirme que a moeda da sua loja Shopify está definida como EUR.',
  shopifyCurrencyConfirmGBP:
    'Por favor, confirme que a moeda da sua loja Shopify está definida como GBP.',
  shopifyCurrencyConfirmMXN:
    'Por favor, confirme que a moeda da sua loja Shopify está definida como MXN.',
  shopifyCurrencyConfirmPEN:
    'Por favor, confirme que a moeda da sua loja Shopify está definida como PEN.',
  shopifyCurrencyConfirmSEK:
    'Por favor, confirme que a moeda da sua loja Shopify está definida como SEK.',
  shopifyDomainUsedByOtherStore:
    'Este domínio já foi utilizado por outra loja Shopify; por favor, altere o status de quaisquer lojas Shopify não utilizadas para "Inativa".',
  paymentbtntext: 'Configurar',
  paymentdoamin: 'Dominio de Pago',
  paymentlanguage: 'Idioma da página de finalização de compra',
  paymentoptions: 'Opções de pagamento',
  paymentoptionsdesc: 'As opções de pagamento aceitas na sua loja.',
  paymenttitle: 'Configure os métodos de pagamento aceitos em sua loja.',
  personalInformationVerification: 'Verificação da informação pessoal',
  personalInformationVerificationSubTitle:
    'Verificação da informação envolve seu número de celular.',
  phone: 'Telefone',
  pixel: 'Pixel',
  pixelIDisRequired: 'O ID do Pixel é obrigatório',
  pixelTokenisRequired: ' O Token do Pixel é obrigatório',
  pixelexample:
    'Exemplo: Um cliente vê seu anúncio, visita seu site e faz uma compra. O Pixel acompanha isso, ajudando você a saber quais anúncios geram mais vendas.',
  pixelhelp:
    'Analise o desempenho de suas campanhas de marketing, vendo como seus clientes interagem com seus anúncios e sua loja.',
  pixelid: 'ID do pixel',
  pixelname: 'Nome do pixel',
  pixeltoken: 'Pixel token',
  platforms: 'PLATAFORMAS',
  pleaseFillTheRequiredFields: 'Por favor, preencha os campos obrigatórios',
  pleaseInput: 'Por favor, insira',
  pleaseInputDomain: 'Por favor, insira o domínio',
  pleaseSelect: 'Por favor, selecione',
  pleaseSelectDate: 'Selecione uma data',
  pleconfirmPWD: 'Por favor, confirme a senha',
  pleinputPWD: 'Por favor, insira a senha',
  popup: 'Popup',
  popupBackground: 'Fundo de Popup',
  popupConfig: 'Configuração de Popup',
  popupConfigDesc: 'Efeito e regras do popup',
  popupCycle: 'Ciclo pop-up',
  popupCycleItem: 'Usuário de primeira vez, pop-up a cada {input} dias',
  preview: 'Prévia',
  previousPage: 'Página Anterior',
  priceTerms: 'Termos de preço',
  privacypolicy: 'Política de Privacidade do USAdrop',
  processingTime:
    'A Parte A cumprirá todos os pedidos da loja da Parte B e atualizará o tempo de processamento, o tempo de envio, as descrições dos produtos na loja da Parte B, etc., de acordo com os requisitos da Parte A. Se houver itens de ajuste, como produtos esgotados e produtos semelhantes, a Parte B deverá concluir o ajuste/remoção em até 12 horas.',
  product: 'Produto',
  productSpecifications:
    'Wrong product, color, size, other SPU, specifications, refunds are borne by Party A',
  productsImitation:
    'Imitation products_imitation brands , the refund shall be borne by Party B',
  propertyRights:
    'É proibido fazer upload e vender produtos que violem direitos de propriedade intelectual.',
  protocolBtnPrefix: 'Eu concordo com',
  protocolBtnTitle:
    'os Termos e Condições de Pagamento e a Política de Privacidade',
  protocolDialog: 'Contrato do Usuário',
  questionsSupport:
    'Se tiver alguma dúvida, utilize nosso material de suporte listado abaixo:',
  recommendSize: 'Tamanho recomendado: {input}',
  recoverpassowrd: 'Recuperar senha',
  recovertitle: 'Digite seu endereço de e-mail abaixo',
  rectifiedAccording: `For refunds of orders that are not rectified according to Party A's requirements, the refund shall be borne by Party B`,
  redirectLink: 'Link de Redirecionamento',
  refundGuaranteeFees: 'Taxas de Garantia de Reembolso',
  refundGuaranteeTerms: 'Termos de Garantia de Reembolso',
  refundShallBe:
    'If the product is not reviewed and the product is out of stock, the refund shall be borne by Party B',
  refundsAreBorne:
    'Logistics information shows that it has not been delivered/updated for a long time, refunds are borne by Party A',
  refundsAreGiven:
    'The product has been reviewed, the product is out of stock and refunds are given to the customer, refunds are borne by Party A',
  register: 'Registrar',
  registersuccess: 'Registro bem-sucedido!',
  registertips:
    'Usaremos seus dados para criar sua conta de acesso e enviar informações que ajudarão você a ativar sua loja.',
  requestNumber: 'NÚMERO DE PEDIDO',
  requests: 'Pedidos',
  requestsCancellation:
    'O pedido não foi enviado e o cliente solicita o cancelamento',
  save: 'Guardar',
  saveFields: 'Depois de preencher os campos, salve o que preencheu.',
  saveSuccessfully: 'Salvo com sucesso',
  search: 'Buscar',
  secondarydomains: 'Domínios secundários',
  selectCountry: 'Selecione País',
  selectTimeZone: 'Selecione Fuso Horário',
  service: 'Configuração',
  serviceemail: 'E-mail de atendimento ao cliente',
  setUpDomain:
    'Configure seu domínio com seu provedor seguindo os passos abaixo.',
  settings: 'Configuração',
  settlementPeriod:
    'Estender o período de liquidação ou suspender a liquidação; A Parte A tem o direito de rescindir o Contrato e não devolvê-lo à Parte B. O valor não liquidado e o depósito serão liquidados em um momento diferente acordado após seis meses.',
  shipped:
    'The order time is less than or equal to 3 days, the order has been shipped, and the customer requests to cancel and refund, and the refund shall be borne by Party B',
  shopify: 'Shopify',
  shopifybtntext: 'Instalar',
  shopifytitle: 'Instale o Checkout Transparente na sua loja Shopify.',
  skipshoppingcart: 'Pular carrinho de compras',
  specificRates: '3、Taxas específicas',
  specificUsageScenarios:
    'Os reembolsos gerados por outros métodos serão arcados pela Parte A. Para cenários de uso específicos,',
  sslCertificate: 'CERTIFICADO de SSL',
  start: 'Início',
  startDate: 'Data de início',
  startUsing: 'Ativo',
  startconfig: 'Comece a configurar aqui',
  status: 'Status',
  step1Content:
    'Vá ao site do seu provedor de domínio. Procure pela seção de configuração de registros DNS.',
  step1Title: 'PASSO 1: ACESSE O PAINEL DO SEU PROVEDOR',
  step2Content:
    'No seu provedor, na seção de configuração de registros DNS, adicione as informações abaixo. Preencha cada campo com as respectivas informações:',
  step2Title: 'PASSO 2: ACESSE O PAINEL DO SEU PROVEDOR',
  step3Content:
    'Após completar corretamente as entradas acima com o seu provedor de domínio, você deve esperar um tempo para que as informações sejam propagadas. Este processo geralmente leva até 4 horas.',
  step3Title: 'PASSO 3: AGUARDE A PROPAGAÇÃO',
  storeAccessingUrl: 'Endereço da loja online',
  storeBinding: 'Vincular da Loja',
  storeBindingSettings: 'Configurar Loja',
  storeLogo: 'Logo da loja',
  storeLogoLimitTips: 'Tamanho recomendado: 230*50 até 200 KB',
  storename: 'Nome da Loja',
  termsofuse: 'termos de uso',
  theCheckoutPage:
    'Valor do desconto/Porcentagem: Na página de checkout, defina um valor/porcentagem de desconto fixo para atrair clientes a escolherem esse método de pagamento.',
  theProductsSold:
    'Os produtos vendidos no site incluem produtos não autorizados pela marca ou que usam marcas registradas não autorizadas pela marca, bem como outros produtos de marca; violação de propriedade intelectual não relacionada à marca, incluindo, mas não se limitando a: filmes, vídeos, músicas, jogos, obras de animação e seus produtos periféricos, incluindo, mas não se limitando a, figuras, acessórios e equipamentos de personagens.',
  theRefundShall:
    'If the customer receives the goods and the delivery time is too long and it does not exceed the store time limit, the refund shall be borne by Party B',
  timezone: 'Fuso horário',
  tips: 'Dicas',
  toEmbedPaymentMethods: 'Para integrar métodos de pagamento.',
  toenter: 'Para entrar',
  tosave: 'Salvar',
  total: 'Total',
  trackingNumber: 'Número de rastreamento',
  transactionSettlement:
    'A Parte B concorda que a Parte A deduzirá as taxas acima do valor de liquidação da transação da Parte B.',
  transferPlatform: 'Plataforma de Pedidos',
  tutorial: 'Tutorial',
  type: 'TIPO:',
  typeofintegration: 'Tipo de integração',
  typepassword: 'Digite sua senha',
  unauthorized:
    'For unauthorized transactions, the refund shall be borne by Party B',
  unauthorizedTransaction: 'Transação não autorizada',
  unconvertedOrder: 'Pedido Não Convertido',
  update: 'Atualizar',
  urlDisplayed:
    'O URL exibido no navegador da web quando os clientes acessam sua loja online é um nome de domínio personalizado.',
  usedNormally: 'Cannot be used normally, refunds are borne by Party A',
  value: 'VALOR:',
  wantsToCancel: 'O cliente compra mais e deseja cancelar e reembolsar',
  whatisapixel: 'O que é um Pixel?',
  whatsAppTemplate: 'Modelo de WhatsApp',
  whichTimeZoneSetTitle: 'Qual fuso horário deve ser definido?',
  withdrawalFeeAnswer:
    'Depende da taxa do seu banco. Bancos diferentes têm taxas diferentes.',
  withdrawalFeeTitle: 'Quais são as taxas para saques?',
  withdrawalMethodAnswer:
    'Após pagar todos os pedidos, você pode sacar dinheiro. Transferência bancária e retirada do Paypal são suportadas.',
  withdrawalMethodTitle: 'Como sacar dinheiro e quais são os métodos de saque?',
  yes: 'Sim',
  mismatched: 'A Parte B',
  mustNotSell: 'não deverá vender produtos de marca registrada nem exibir logotipos ou elementos de marca nas descrições dos produtos. ',
  brandIconsMust:
    'A Parte B não deverá vender produtos de marca registrada nem exibir logotipos ou elementos de marca nas descrições dos produtos. Caso a Parte A identifique produtos de marca não autorizados, produtos ilegais ou produtos inconsistentes na loja da Parte B, a Parte A suspenderá todos os pagamentos à loja da Parte B no prazo de até 6 horas e interromperá todos os repasses. A Parte A terá o direito de processar reembolsos para quaisquer pedidos não conformes ou que violem as políticas, sendo todos os custos, perdas e despesas decorrentes dessas situações de responsabilidade exclusiva da Parte B. O valor específico da multa é mostrado em',
  theRefund:
    'Se o motivo do reembolso se enquadrar nas seguintes cinco situações após a verificação, o reembolso será arcado pela Parte B: ',
  refundGuarantee: 'Termos de Garantia de Reembolso.',
  priceList: 'Lista de preços',
  Holding: 'Retenção',
  appendixTwo: 'Anexo 2.',
  paymentPriceList: 'Lista de preços de pagamento',
  howDoes: 'O que é Dropshipping e como funciona',
  whatIsPayment: 'O que é USAdrop Payment',
  differenceDropshipping:
    'A diferença entre pagamento na entrega e Dropshipping',
  howsySterm: 'Como usar o USAdrop sistema',
  howShopifyAPI: 'Como configurar a API do Shopify',
  howDomain: 'Como configurar o domínio',
  howPixel: 'Como configurar o Pixel',
  howCoupon: 'Como configurar um Cupom',
  pleaseShopifyStore:
    'Por favor, certifique-se de que o domínio se conecte à sua loja Shopify!',
  feeTerms: 'Condições',
  noRefundGuarantee: 'Nenhuma taxa de garantia de reembolso no Brasil',
  deleteShopify:
    'Como excluir ou adicionar o botão dinâmico "Compre agora" e o botão "Adicionar ao carrinho" no Shopify',
  stepOne: 'Etapa 1, navegue até "Loja virtual" → "Temas" → "Personalizar"',
  stepTwo:
    'Etapa 2 - Navegue até "Produtos" → "Produto padrão" → entre na página de descrição do produto',
  stepThree:
    'Etapa 3 - Clique em "Botões Comprar" → Clique para ativar "Exibir botões de checkout dinâmico" → "Salvar"',
  dynamicCheckoutButton: 'Como configurar o botão de checkout dinâmico',
  personalInformationTitle: 'Minha Conta Informação',
  personalInformationSubTitle:
    'Verificação da informação da conta é um processo de assegurar que sua informação seja precisa e atual. Ela envolve verificar seu número de telefone para garantir que é correto e atual.',
  personalInformationTips:
    'Nota:\n' +
    'Para garantir a autenticidade das suas informações de identidade, precisamos verificar o seu número de' +
    ' telefone celular. O nome e o número de telefone celular não podem ser modificados após a verificação e' +
    ' vinculação.Se você não puder receber o código de verificação ou precisar modificá-lo, entre em contato com o serviço de atendimento ao cliente/agente de USAdrop Payment.',
  contactName: 'Nome de contato',
  contactPhone: 'Número de telefone',
  contactPhoneAreaCode: 'Código da Área Telefónica',
  getVerificationCode: 'OBTER CÓDIGO DE VERIFICAÇÃO',
  verificationCode: 'Código de verificação',
  pleaseEnter: 'Por favor insira {input}',
  pleaseSelect2: 'Por favor selecione {input}',
  fulfillmentPlatform: 'Plataforma de Cumprimento',
  pleaseEnterCorrect: 'Por favor, insira o {input} correto',
  sendSuccessfully: 'Enviar com sucesso',
  submitSuccessfully: 'Enviar com sucesso',
  serviceUnavailable: 'O serviço não está disponível',
  loginExpired: 'Sessão expirada, faça login novamente',
  toVerification: 'Para a Verificação',
  activeCustomerPaymentTips:
    'A verificação de dados pessoais ainda não foi concluída, portanto, o serviço de pagamento não pode ser utilizado.',
  activeCustomerPaymentTips2: `Clique em "Verificação da informação pessoal" para concluir o processo de validação das informações.`,
  skipCartTips1:
    'Este recurso ajuda a aumentar as taxas de conversão de pedidos únicos, mas reduz as taxas de adição ao carrinho. Ative-o conforme necessário.',
  skipCartTips2: `Quando ativado, o USAdrop Payment desabilitará o botão "Add to Cart" (Adicionar ao Carrinho) do Shopify e manterá apenas os botões de checkout dinâmicos. Clientes que clicarem nesses botões serão direcionados diretamente para a página de checkout.`,
  skipCartTips3:
    '(Se o botão de checkout não estiver visível nas páginas de produtos após ativar este recurso, siga o tutorial para ativar os botões de checkout dinâmicos:',
  advertisingMaterial: 'Tutorial de material publicitário',
  violationRecord: 'Registros de Violações',
  store: 'Loja',
  state: 'Estado',
  deadline: 'Prazo final',
  needModified: 'Precisa ser modificado',
  reviewing: 'Revisando',
  completed: 'Concluído',
  types: 'Tipo',
  link: 'Link',
  picture: 'Foto',
  details: 'Detalhes',
  overdue: 'Atrasado',
  rejected: 'Rejeitado',
  operate: 'operar',
  complete: 'Completo',
  completeTips:
    'Estamos prestes a enviar para revisão, por favor, certifique-se de que as modificações foram concluídas conforme necessário!',
  remark: 'Observação',
  remarkPlaceholder: 'Por favor, insira uma observação',
  pleaseInputRemark: 'Por favor, preencha a observação',
  facebookPixel: 'Como configurar o Facebook Pixel?',
  googlePixel: 'Como configurar o Google Pixel?',
  themeColor: 'Cor do Tema',
  themeColorTips:
    'Você pode usar esta configuração para modificar a cor do tema da interface de "checkout".',
  buttonColor: 'Cor do Comprar agora',
  buttonColorTips:
    'Você pode usar esta configuração para alterar a cor do botão "Comprar agora".',
  terminationAgreement: 'Rescisão do Contrato',
  installment: 'Parcelamento',
  unhandledStores: 'Você tem lojas ilegais',
  pixelTop1: 'O GTM já está vinculado. Você não pode adicionar outro pixel.',
  pixelTop2: 'Desative o pixel atual antes de usar o GTM.',
  pixelTop3:
    'O GTM e outros pixels não podem funcionar ao mesmo tempo. Precisa de ajuda? Entre em contato com seu agente.',
  successVideoTop: 'Histórias de Sucesso Reais',
  paypalTop:
    'Entre em contato com nosso agente para ativar o pagamento pelo Paypal.',
  errorMessage: 'Ocorreu um erro no servidor',
  wiioRechargeTitle: 'Aviso',
  wiioRechargeDesc: 'Por favor, pague a mensalidade para usar a plataforma.',
  wiilRechargeConfirm: 'Ir para USAdrop',
  orderPageDesigner: 'Editor de Checkout',
  export: 'Exportar',
  exporting: 'Exportando...',
  unknownError: 'Erro desconhecido',
  downloadSuccess: 'Download concluído',
  defaultExportNotice:
    'Por padrão, os registros dos últimos 30 dias serão exportados; você pode selecionar um intervalo máximo de 30 dias',
  pageStyleConfig: 'Configuração de Estilo da Página',
  reset: 'Redefinir',
  limitedTimeOffer:
    'Oferta por tempo limitado! Faça seu pedido agora e aproveite o desconto!',
  countdownToEnd: 'Tempo até o fim da promoção:',
  configLoadedSuccess: 'Dados de configuração carregados com sucesso',
  configLoadedUseDefault:
    'Falha ao carregar os dados de configuração, usando valores padrão',
  configLoadFailed:
    'Falha ao obter a configuração, verifique a rede ou o serviço',
  confirmRestore:
    'Tem certeza de que deseja restaurar a configuração? Esta ação é irreversível',
  warning: 'Aviso',
  confirmReset: 'Confirmar redefinição',
  submitSuccess: 'Enviado com sucesso',
  checkoutConfigSaved:
    'A configuração da página de checkout foi salva e aplicada com sucesso!',
  saveConfigFailed:
    'Falha ao salvar a configuração, tente novamente mais tarde.',
  visualSizeConfig: 'Configuração Visual e de Tamanho',
  width: 'Largura',
  height: 'Altura',
  textAndCountdownConfig:
    'Configuração de Texto e Contagem Regressiva (Copy de Marketing)',
  textContent: 'Conteúdo do Texto',
  enterMarketingCopy: 'Insira o texto de marketing',
  fontSize: 'Tamanho da Fonte',
  fontColor: 'Cor da Fonte',
  fontWeight: 'Espessura da Fonte',
  selectWeight: 'Selecione a espessura',
  countdownSettings: 'Configurações de Contagem Regressiva',
  enableCountdown: 'Ativar contagem regressiva',
  countdownPrefix: 'Prefixo da contagem regressiva',
  examplePrefix: 'Exemplo: Até o fim',
  endTime: 'Hora de término',
  selectEndTime: 'Selecione o horário de término da contagem',
  textSpacing: 'Espaçamento entre Texto/Timer',
  realtimePreview: 'Pré-visualização em tempo real',
  eventEnded: 'O evento terminou',
  rowInfo: 'Informações da linha {index}',
  icon: 'Ícone',
  title: 'Título',
  bottomTextConfig: 'Configuração de Texto Inferior',
  text: 'Texto',
  suggestedSize: 'Tamanho sugerido',
  logo: 'Logo',
  banner: 'Banner',
  safetyInfo: 'Informações de Segurança',
  securityIcons: 'Ícones de Segurança',
  description: 'Descrição',
  confirmSavePageStyle:
    'Tem certeza de que deseja salvar a configuração atual do estilo da página? Após salvar, ela será aplicada imediatamente na página de checkout.',
  getCodeTip:
    'Por favor, complete primeiro o domínio da loja, a chave da API e a chave secreta.',
  getCode: 'Obter código',
  token_helper_tip:
    'Obtenha o Access Token automaticamente usando suas credenciais do Dev Dashboard.',
  copySuccess: 'Copiado!',
  pleaseFillInClientIdAndSecret:
    'Por favor, preencha o Client ID (API Key) e Secret (API Secret Key)',
  pleaseEnterClientIdAndSecret:
    'Por favor, insira o Client ID (API Key) e Secret (API Secret Key)',
  pleaseFillInClientIdAndSecretFirst:
    'Por favor, preencha primeiro o Client ID (API Key) e Secret (API Secret Key)',
  pleaseContactAgent: 'Por favor entre em contato com o agente',
  createStoreMexicoUSAdropPaymentsTitle: 'Crie sua Loja Shopify do Zero',
  couponDisplayConfig: 'Exibição do cupom',
  displayMode: 'Modo de exibição',
  couponDisplayExpand: 'Expandido',
  couponDisplayHide: 'Oculto',
  couponHideModeTipStart:
    'Quando habilitado, o campo de cupom fica oculto por padrão. Se você configurou um',
  couponHideModeTipEnd:
    'e ele está ativo, será aplicado automaticamente quando o cliente fizer um segundo pedido. Se você não quiser que os clientes usem códigos de desconto, defina o status do cupom como "Desativado".',
  couponDisplayCollapse: 'Recolhido',
  couponUnselected: 'Não selecionado',
  couponNoAvailable: 'Sem cupons disponíveis',
  couponNoCode: 'Não é necessário preencher',
  productPrice: 'Produto',
  productDiscount: 'Desconto',
  productShipping: 'Enviar',
  free: 'Grátis',
  apply: 'Aplicar',
  orderPreviewPriceProduct: '$9999.00',
  orderPreviewPriceDiscount: '-$0.00',
  orderPreviewPriceTotal: '$9999.00',
  uponTransactionRisks: `Caso o consumidor apresente uma solicitação de reembolso, a Parte A reserva-se o direito, a seu exclusivo critério, de processar o reembolso da transação, total ou parcial, com o objetivo de mitigar riscos transacionais mais graves ou potenciais.`
}
